import { templateToTitle } from '@apps/card/utils';
import Fuse from 'fuse.js';
import { useMemo } from 'react';
import { FUSE_OPTIONS } from './Search.constants';

export function useFuse<T extends { name?: string | null | undefined }>(templates: ReadonlyArray<T>) {
  return useMemo(() => {
    return new Fuse(templates, {
      ...FUSE_OPTIONS,
      keys: ['name'],
      getFn: item => templateToTitle(item),
      includeScore: true,
    });
  }, [templates]);
}
